import React, { useState, useImperativeHandle, forwardRef } from 'react';

import BayModal from '../../BayModal';

import type { TranslationFunction } from '../../types/common';

interface CancelAllWarningModalProps {
	cancelAllFileUpload: () => void;
	t: TranslationFunction;
}

export interface CancelAllWarningModalHandle {
	setShowModal: (val: boolean) => void;
}

const CancelAllWarningModal = forwardRef<CancelAllWarningModalHandle, CancelAllWarningModalProps>(
	({ cancelAllFileUpload, t }, ref) => {
	const [showModal, setShowModal] = useState(false);

	useImperativeHandle(ref, () => {
		return {
			setShowModal(val) {
				setShowModal(val);
			},
		};
	}, []);

	const handleCancel = () => {
		setShowModal(false);
	};

	const handleConfirm = () => {
		// Execute cancellation immediately
		if (typeof cancelAllFileUpload === 'function') {
			cancelAllFileUpload();
		}

		// Close the modal after cancellation
		setShowModal(false);
	};

	return (
		<div ref={ref}>
			<BayModal
				backdrop="static"
				buttonText={t('proceed')}
				cancelText={t('close')}
				closeButton={true}
				id="cancel_all_uploads_modal"
				show={showModal}
				submitFunc={handleConfirm}
				title={t('cancelAllUploads')}
				variant="danger"
				onHideFunc={handleCancel}
			>
				<p className="mb-0">{t('cancelUploadConfirmation')}</p>
			</BayModal>
		</div>
	);
});

CancelAllWarningModal.displayName = 'CancelAllWarningModal';

export default CancelAllWarningModal;
